import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from "react-router-dom";
import './index.css';
import Router from './component/Router';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

// ✅ Google Analytics
import ReactGA from "react-ga4";

// ✅ ADD THIS
import { HelmetProvider } from "react-helmet-async";

// ✅ INITIALIZE GA
ReactGA.initialize("G-0THZJH96C7");

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <HelmetProvider> {/* 👈 IMPORTANT */}
      <BrowserRouter>
        <Router />
      </BrowserRouter>
    </HelmetProvider>
  </React.StrictMode>
);